import React, { useState } from "react";
import axios from "axios";
import { useUserInfo } from "../../../context/user";
import env from "../../../config/env";
import { useNavigate, useLocation } from "react-router-dom";
import YoureAllSet from "./YoureAllSet"; // ✅ adjust the path if different
import { useAppServices } from "../../../hook/services";
import { Toast } from "../../../components/Toast/Toast";

const ConfigureYourAIWeb = ({ setBusinessType, setSuccess, HandleEveryStep }) => {
  const [loading, setLoading] = useState(false);
  const [websiteUrl, setWebsiteUrl] = useState("");
  const Service = useAppServices();
  const [inputError, setInputError] = useState("");
  const [toastVisible, setToastVisible] = useState(false);
  const [toastType, setToastType] = useState("error");
  const [toastMessage, setToastMessage] = useState("");
  const [toastSubMessage, setToastSubMessage] = useState("");
  const [isAnimationCompleted, setIsAnimationCompleted] = useState(false);

  const location = useLocation();
  const { accountDataLocation } = location.state || {};

  console.log("Account ID from navigation:", accountDataLocation);

  const [
    userInfo,
    ,
    ,
    // user, Update, clear
    setUserActiveLocation,
    userActiveLocation,
    saveActiveLocation, // ⬅️ we’ll reuse the existing helper
  ] = useUserInfo();

  const navigate = useNavigate();
  const BASE_URL = `${env.API_URL}/v1`;

  const isValidUrl = (value) => {
    const trimmed = (value || "").trim();
    if (!trimmed) return false;
    // Accepts domains with or without an http(s):// prefix, e.g. example.com or https://example.com/path
    const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/i;
    return urlPattern.test(trimmed);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidUrl(websiteUrl)) {
      setInputError("This URL is invalid. Please check the address and try again.");
      return;
    }
    setInputError("");

    setLoading(true);
    setIsAnimationCompleted(true);
    setSuccess(true)

    try {
      const payload = {
        website_url: websiteUrl,
        profileId: accountDataLocation
          ? accountDataLocation
          : userActiveLocation?.id,
        username: userActiveLocation?.business_name || userActiveLocation?.first_name,
      };

      const data = await axios.post(`${BASE_URL}/users/onboarding`, payload);

      if (data) {
        const payload = {
          onboarding: {
            ...userActiveLocation?.onboarding,
            website_url: websiteUrl,
            email: userInfo.email,
            verified:
              userInfo?.verified === undefined ? true : userInfo.verified,
          },
          _id: accountDataLocation
            ? accountDataLocation
            : userActiveLocation?.id,
        };
        const { response } = await Service.accounts.update({
          payload,
          toaster: true,
        });
        if (response?.success) {
          HandleEveryStep(5);
          await saveActiveLocation(response.data)
          setUserActiveLocation(response.data);
          setToastMessage(null);
          setLoading(false);
        }
      }
    } catch (error) {
      const backendMessage =
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        "";
      const isNetworkError =
        error.code === "ERR_NETWORK" ||
        error.message === "Network Error" ||
        !error.response ||
        /ENOTFOUND|getaddrinfo|ECONNREFUSED|ETIMEDOUT|EAI_AGAIN/i.test(
          backendMessage
        );

      if (isNetworkError) {
        setToastType("error");
        setToastMessage("We’re having trouble connecting.");
        setToastSubMessage(
          "Please check your internet connection and try again."
        );
        setToastVisible(true);
      } else if (
        error.response?.data?.error?.err ===
        "Bad request, domain is not reachable"
      ) {
        setToastType("error");
        setToastMessage("The website address you entered could not be reached");
        setToastSubMessage(
          "Please ensure that you have provided a valid and accessible URL"
        );
        setToastVisible(true);
      } else if (
        error.response?.data?.error?.error ===
        "Bad request, no abstract generated"
      ) {
        setToastType("error");
        setToastMessage(
          "The website you entered does not contain enough information to process"
        );
        setToastSubMessage(
          "Please upload a brochure, presentation or sales document instead."
        );
        setToastVisible(true);
      } else {
        setToastType("error");
        setToastMessage("Onboarding failed. Please try again later.");
        setToastSubMessage("Unexpected error occurred");
        setToastVisible(true);
      }
      setLoading(false);
    }
  };

  if (isAnimationCompleted) {
    return (
      <YoureAllSet
        success={loading}
        onComplete={async () => {
          if (!toastMessage && !loading) {
            // Check if payment is required before navigating
            if (userActiveLocation?.type === "premium" && !userActiveLocation?.subscription_id) {
              try {
                const resp = await Service.saas.fetchPlanById({ plan: userActiveLocation.plan_id });
                if (!resp.response?.data?.is_free_saas) {
                  navigate("/auth/add-payment");
                  return;
                }
              } catch (e) {
                console.error("Error checking plan:", e);
              }
            }
            navigate("/app/chat")
          } else {
            setIsAnimationCompleted(false)
          }
        }}
      />
    );
  }

  return (
    <div className="!bg-white">
      <div className="container-main !w-[430px] bg-white">
        <div className="container pb-10 bg-white">
          <div className="text-center">
            <h1 className="text-[30px] font-medium">Configure Your AI</h1>
            <p
              className={`mt-4 ${toastMessage ? "text-[#C00F0C]" : "text-black"
                }`}
            >
              {toastMessage && toastMessage + " " + toastSubMessage}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="loginForm w-[380px] mt-10">
            <div className="mb-2">
              <input
                type="text"
                name="website_url"
                placeholder="Website URL"
                value={websiteUrl}
                onChange={(e) => setWebsiteUrl(e.target.value)}
                className="w-full"
                autoComplete="off"
              />
              {inputError && (
                <p className="text-red-500 text-start text-sm mt-1">
                  {inputError}
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={loading || !websiteUrl}
              style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
              className={`${loading || !websiteUrl
                ? "!bg-[#F5F5F5] border !border-[#D9D9D9] !text-black"
                : "bg-black text-white"
                } mt-5`}
            >
              {loading ? "Loading..." : "Let\u2019s go!"}
            </button>
          </form>
        </div>

        <span
          onClick={() => setBusinessType(null)}
          className="text-[#757575] text-[12px] ml-8 cursor-pointer"
        >
          ← Go back
        </span>
      </div>

      <Toast
        type={toastType}
        message={toastMessage}
        subMessage={toastSubMessage}
        visible={toastVisible}
        onClose={() => setToastVisible(false)}
      />
    </div>
  );
};

export default ConfigureYourAIWeb;
